import { LOGOUT_SUCCESS } from '../auth/types';
import {
  DELETE_VIRTUAL_OPERATOR_MESSAGE_FAILURE,
  DELETE_VIRTUAL_OPERATOR_MESSAGE_REQUEST,
  DELETE_VIRTUAL_OPERATOR_MESSAGE_SUCCESS,
  FETCH_ENTERPRISE_DATA_FAILURE,
  FETCH_ENTERPRISE_DATA_REQUEST,
  FETCH_ENTERPRISE_DATA_SUCCESS,
  FETCH_VIRTUAL_OPERATOR_AMBROGIO_COSTS_FAILURE,
  FETCH_VIRTUAL_OPERATOR_AMBROGIO_COSTS_REQUEST,
  FETCH_VIRTUAL_OPERATOR_AMBROGIO_COSTS_SUCCESS,
  FETCH_VIRTUAL_OPERATOR_AMBROGIO_PBXS_FAILURE,
  FETCH_VIRTUAL_OPERATOR_AMBROGIO_PBXS_REQUEST,
  FETCH_VIRTUAL_OPERATOR_AMBROGIO_PBXS_SUCCESS,
  FETCH_VIRTUAL_OPERATOR_CHAT_DETAILS_FAILURE,
  FETCH_VIRTUAL_OPERATOR_CHAT_DETAILS_REQUEST,
  FETCH_VIRTUAL_OPERATOR_CHAT_DETAILS_SUCCESS,
  FETCH_VIRTUAL_OPERATOR_COSTS_FAILURE,
  FETCH_VIRTUAL_OPERATOR_COSTS_REQUEST,
  FETCH_VIRTUAL_OPERATOR_COSTS_SUCCESS,
  FETCH_VIRTUAL_OPERATOR_MESSAGES_FAILURE,
  FETCH_VIRTUAL_OPERATOR_MESSAGES_REQUEST,
  FETCH_VIRTUAL_OPERATOR_MESSAGES_SUCCESS,
  FETCH_VIRTUAL_OPERATOR_MONITORING_FAILURE,
  FETCH_VIRTUAL_OPERATOR_MONITORING_REQUEST,
  FETCH_VIRTUAL_OPERATOR_MONITORING_SUCCESS,
  FETCH_VIRTUAL_OPERATOR_SETTINGS_FAILURE,
  FETCH_VIRTUAL_OPERATOR_SETTINGS_REQUEST,
  FETCH_VIRTUAL_OPERATOR_SETTINGS_SUCCESS,
  FETCH_VIRTUAL_OPERATOR_STATISTICS_FAILURE,
  FETCH_VIRTUAL_OPERATOR_STATISTICS_REQUEST,
  FETCH_VIRTUAL_OPERATOR_STATISTICS_SUCCESS,
  FETCH_VIRTUAL_OPERATOR_USERS_FAILURE,
  FETCH_VIRTUAL_OPERATOR_USERS_REQUEST,
  FETCH_VIRTUAL_OPERATOR_USERS_SUCCESS,
  SAVE_ENTERPRISE_FESTIVITIES_FAILURE,
  SAVE_ENTERPRISE_FESTIVITIES_REQUEST,
  SAVE_ENTERPRISE_FESTIVITIES_SUCCESS,
  SAVE_ENTERPRISE_INFO_FAILURE,
  SAVE_ENTERPRISE_INFO_REQUEST,
  SAVE_ENTERPRISE_INFO_SUCCESS,
  SAVE_ENTERPRISE_MESSAGE_FAILURE,
  SAVE_ENTERPRISE_MESSAGE_REQUEST,
  SAVE_ENTERPRISE_MESSAGE_SUCCESS,
  SAVE_OPENING_FAILURE,
  SAVE_OPENING_REQUEST,
  SAVE_OPENING_SUCCESS,
  SAVE_VIRTUAL_OPERATOR_MESSAGE_FAILURE,
  SAVE_VIRTUAL_OPERATOR_MESSAGE_REQUEST,
  SAVE_VIRTUAL_OPERATOR_MESSAGE_SUCCESS,
  SAVE_VIRTUAL_OPERATOR_NO_CREDIT_RULE_FAILURE,
  SAVE_VIRTUAL_OPERATOR_NO_CREDIT_RULE_REQUEST,
  SAVE_VIRTUAL_OPERATOR_NO_CREDIT_RULE_SUCCESS,
  SAVE_VIRTUAL_OPERATOR_OFFICE_FAILURE,
  SAVE_VIRTUAL_OPERATOR_OFFICE_REQUEST,
  SAVE_VIRTUAL_OPERATOR_OFFICE_SUCCESS,
  SAVE_VIRTUAL_OPERATOR_SETTINGS_CLOSING_FAILURE,
  SAVE_VIRTUAL_OPERATOR_SETTINGS_CLOSING_REQUEST,
  SAVE_VIRTUAL_OPERATOR_SETTINGS_CLOSING_SUCCESS,
  SAVE_VIRTUAL_OPERATOR_SETTINGS_FESTIVITIES_FAILURE,
  SAVE_VIRTUAL_OPERATOR_SETTINGS_FESTIVITIES_REQUEST,
  SAVE_VIRTUAL_OPERATOR_SETTINGS_FESTIVITIES_SUCCESS,
  SAVE_VIRTUAL_OPERATOR_TICKET_SETTINGS_FAILURE,
  SAVE_VIRTUAL_OPERATOR_TICKET_SETTINGS_REQUEST,
  SAVE_VIRTUAL_OPERATOR_TICKET_SETTINGS_SUCCESS,
  SAVE_VIRTUAL_OPERATOR_USER_FAILURE,
  SAVE_VIRTUAL_OPERATOR_USER_REQUEST,
  SAVE_VIRTUAL_OPERATOR_USER_SUCCESS,
  SET_VIRTUAL_OPERATOR_STATISTICS_FILTER,
} from './types';

const initialState = {
  saveFestivitiesLoaded: true,
  saveFestivitiesError: false,
  saveEnterpriseInfoLoaded: true,
  saveEnterpriseInfoError: false,
  enterpriseFestivities: [],
  enterpriseFestivitiesMessage: null,
  enterpriseInfoLoaded: true,
  enterpriseInfoError: false,
  enterpriseInfo: '',
  saveOpeningLoaded: true,
  saveOpeningError: false,
  openingTable: {},
  openingMessage: null,
  fetchUsersLoaded: true,
  fetchUsersError: false,
  users: [],
  saveUserLoaded: true,
  saveUserError: false,
  saveOfficeLoaded: true,
  saveOfficeError: false,
  fetchMessagesLoaded: true,
  fetchMessagesError: false,
  messages: [],
  saveMessageLoaded: true,
  saveMessageError: null,
  deleteMessageError: false,
  deleteMessageLoaded: true,
  saveEnterpriseWelcomeMessageLoaded: true,
  saveEnterpriseWelcomeMessageError: false,
  fetchSettingsLoaded: true,
  fetchSettingsError: false,
  settings: {},
  saveSettingsFestivitiesLoaded: true,
  saveSettingsFestivitiesError: false,
  saveSettingsFestivitiesSuccess: false,
  saveSettingsClosingLoaded: true,
  saveSettingsClosingError: false,
  saveSettingsClosingSuccess: false,
  fetchStatisticsLoaded: true,
  fetchStatisticsError: false,
  statistics: [],
  fetchChatDetailsLoaded: true,
  fetchChatDetailsError: false,
  details: {},
  statisticsFilter: {
    ticket: '',
    contactNumber: '',
    channel: '',
    start: '',
    end: '',
    abook: null,
  },
  fetchMonitoringLoaded: true,
  fetchMonitoringError: false,
  monitoring: {},
  fetchCostsLoaded: true,
  fetchCostsError: false,
  costs: [],
  ambrogioCosts: [],
  totalAmbrogioCosts: 0,
  totalAmbrogioExtraCosts: 0,
  fetchAmbrogioCostsLoaded: true,
  fetchAmbrogioCostsError: false,
  ambrogioPbxs: [],
  fetchAmbrogioPbxsLoaded: true,
  fetchAmbrogioPbxsError: false,
  saveNoCreditRuleLoaded: true,
  saveNoCreditRuleError: false,
  saveNoCreditRuleSuccess: false,
  saveTicketSettingsLoaded: true,
  saveTicketSettingsError: false,
  saveTicketSettingsSuccess: false,
};

export default function videocalls(state = initialState, action = {}) {
  switch (action.type) {
    case LOGOUT_SUCCESS:
      return initialState;

    case FETCH_ENTERPRISE_DATA_REQUEST:
      return {
        ...state,
        enterpriseInfoLoaded: false,
        enterpriseInfoError: false,
      };

    case FETCH_ENTERPRISE_DATA_SUCCESS: {
      return {
        ...state,
        welcomeMessage: action.data.welcomeMessage,
        enterpriseFestivities: action.data.festivities,
        enterpriseFestivitiesMessage: action.data.festivitiesMessage,
        openingTable: action.data.openingTable,
        openingMessage: action.data.openingMessage,
        enterpriseInfo: action.data.virtualOperatorInfo,
        enterpriseInfoLoaded: true,
        enterpriseInfoError: false,
      };
    }

    case FETCH_ENTERPRISE_DATA_FAILURE:
      return {
        ...state,
        enterpriseInfoLoaded: true,
        enterpriseInfoError: true,
      };

    case SAVE_ENTERPRISE_MESSAGE_REQUEST:
      return {
        ...state,
        saveEnterpriseWelcomeMessageLoaded: false,
        saveEnterpriseWelcomeMessageError: false,
      };

    case SAVE_ENTERPRISE_MESSAGE_SUCCESS:
      return {
        ...state,
        welcomeMessage: action.data.message,
        saveEnterpriseWelcomeMessageLoaded: true,
        saveEnterpriseWelcomeMessageError: false,
      };

    case SAVE_ENTERPRISE_MESSAGE_FAILURE:
      return {
        ...state,
        saveEnterpriseWelcomeMessageLoaded: true,
        saveEnterpriseWelcomeMessageError: true,
      };

    case SAVE_ENTERPRISE_FESTIVITIES_REQUEST:
      return {
        ...state,
        saveFestivitiesLoaded: false,
        saveFestivitiesError: false,
      };

    case SAVE_ENTERPRISE_FESTIVITIES_SUCCESS:
      return {
        ...state,
        enterpriseFestivities: action.data.festivities,
        enterpriseFestivitiesMessage: action.data.message,
        saveFestivitiesLoaded: true,
        saveFestivitiesError: false,
      };

    case SAVE_ENTERPRISE_FESTIVITIES_FAILURE:
      return {
        ...state,
        saveFestivitiesLoaded: true,
        saveFestivitiesError: true,
      };

    case SAVE_ENTERPRISE_INFO_REQUEST:
      return {
        ...state,
        saveEnterpriseInfoLoaded: false,
        saveEnterpriseInfoError: false,
      };

    case SAVE_ENTERPRISE_INFO_SUCCESS:
      return {
        ...state,
        enterpriseInfo: action.data.info,
        saveEnterpriseInfoLoaded: true,
        saveEnterpriseInfoError: false,
      };

    case SAVE_ENTERPRISE_INFO_FAILURE:
      return {
        ...state,
        saveEnterpriseInfoLoaded: true,
        saveEnterpriseInfoError: true,
      };

    case SAVE_OPENING_REQUEST:
      return {
        ...state,
        saveOpeningLoaded: false,
        saveOpeningError: false,
      };

    case SAVE_OPENING_SUCCESS:
      return {
        ...state,
        openingTable: action.data.opening,
        openingMessage: action.data.message,
        saveOpeningLoaded: true,
        saveOpeningError: false,
      };

    case SAVE_OPENING_FAILURE:
      return {
        ...state,
        saveOpeningLoaded: true,
        saveOpeningError: true,
      };

    case FETCH_VIRTUAL_OPERATOR_USERS_REQUEST:
      return {
        ...state,
        fetchUsersLoaded: false,
        fetchUsersError: false,
      };

    case FETCH_VIRTUAL_OPERATOR_USERS_SUCCESS:
      return {
        ...state,
        users: action.data.users,
        totalUsers: action.data.total,
        fetchUsersLoaded: true,
        fetchUsersError: false,
      };

    case FETCH_VIRTUAL_OPERATOR_USERS_FAILURE:
      return {
        ...state,
        fetchUsersLoaded: true,
        fetchUsersError: true,
      };

    case SAVE_VIRTUAL_OPERATOR_USER_REQUEST:
      return {
        ...state,
        saveUserLoaded: false,
        saveUserError: false,
      };

    case SAVE_VIRTUAL_OPERATOR_USER_SUCCESS:
      return {
        ...state,
        users: state.users.map((user) => {
          if (user.id !== action.data.id) {
            return user;
          }
          return {
            ...user,
            alias: action.data.data.alias,
            pronunciation: action.data.data.pronunciation,
            transfer: action.data.data.transfer,
            enabled: action.data.data.enabled,
            office: action.data.idQueue,
          };
        }),
        saveUserLoaded: true,
        saveUserError: false,
      };

    case SAVE_VIRTUAL_OPERATOR_USER_FAILURE:
      return {
        ...state,
        saveUserLoaded: true,
        saveUserError: true,
      };

    case SAVE_VIRTUAL_OPERATOR_OFFICE_REQUEST:
      return {
        ...state,
        saveOfficeLoaded: false,
        saveOfficeError: false,
      };

    case SAVE_VIRTUAL_OPERATOR_OFFICE_SUCCESS:
      return {
        ...state,
        saveOfficeLoaded: true,
        saveOfficeError: false,
      };

    case SAVE_VIRTUAL_OPERATOR_OFFICE_FAILURE:
      return {
        ...state,
        saveOfficeLoaded: true,
        saveOfficeError: true,
      };

    case FETCH_VIRTUAL_OPERATOR_MESSAGES_REQUEST:
      return {
        ...state,
        fetchMessagesLoaded: false,
        fetchMessagesError: false,
      };

    case FETCH_VIRTUAL_OPERATOR_MESSAGES_SUCCESS:
      return {
        ...state,
        messages: action.data.messages,
        totalMessages: action.data.total,
        fetchMessagesLoaded: true,
        fetchMessagesError: false,
      };

    case FETCH_VIRTUAL_OPERATOR_MESSAGES_FAILURE:
      return {
        ...state,
        fetchMessagesLoaded: true,
        fetchMessagesError: true,
      };

    case SAVE_VIRTUAL_OPERATOR_MESSAGE_REQUEST:
      return {
        ...state,
        saveMessageLoaded: false,
        saveMessageError: null,
      };

    case SAVE_VIRTUAL_OPERATOR_MESSAGE_SUCCESS:
      let found = false;
      const messages = state.messages.map((message) => {
        if (message.id === action.data.id) {
          found = true;
          return {
            ...message,
            text: action.data.data.text,
            name: action.data.data.name,
          };
        }
        return message;
      });
      if (!found) {
        messages.push({
          id: action.data.id,
          text: action.data.data.text,
          name: action.data.data.name,
        });
      }
      return {
        ...state,
        messages,
        saveMessageLoaded: true,
        saveMessageError: null,
      };

    case SAVE_VIRTUAL_OPERATOR_MESSAGE_FAILURE:
      return {
        ...state,
        saveMessageLoaded: true,
        saveMessageError: action.error,
      };

    case DELETE_VIRTUAL_OPERATOR_MESSAGE_REQUEST:
      return {
        ...state,
        deleteMessageError: false,
        deleteMessageLoaded: false,
      };

    case DELETE_VIRTUAL_OPERATOR_MESSAGE_SUCCESS:
      return {
        ...state,
        deleteMessageError: false,
        deleteMessageLoaded: true,
      };

    case DELETE_VIRTUAL_OPERATOR_MESSAGE_FAILURE:
      return {
        ...state,
        deleteMessageError: true,
        deleteMessageLoaded: true,
      };

    case FETCH_VIRTUAL_OPERATOR_SETTINGS_REQUEST:
      return {
        ...state,
        fetchSettingsLoaded: false,
        fetchSettingsError: false,
      };
    case FETCH_VIRTUAL_OPERATOR_SETTINGS_SUCCESS:
      return {
        ...state,
        settings: action.data,
        fetchSettingsLoaded: true,
        fetchSettingsError: false,
      };
    case FETCH_VIRTUAL_OPERATOR_SETTINGS_FAILURE:
      return {
        ...state,
        fetchSettingsLoaded: true,
        fetchSettingsError: true,
      };
    case SAVE_VIRTUAL_OPERATOR_SETTINGS_FESTIVITIES_REQUEST:
      return {
        ...state,
        saveSettingsFestivitiesLoaded: false,
        saveSettingsFestivitiesError: false,
        saveSettingsFestivitiesSuccess: false,
      };
    case SAVE_VIRTUAL_OPERATOR_SETTINGS_FESTIVITIES_SUCCESS:
      return {
        ...state,
        saveSettingsFestivitiesLoaded: true,
        saveSettingsFestivitiesError: false,
        saveSettingsFestivitiesSuccess: true,
      };
    case SAVE_VIRTUAL_OPERATOR_SETTINGS_FESTIVITIES_FAILURE:
      return {
        ...state,
        saveSettingsFestivitiesLoaded: true,
        saveSettingsFestivitiesError: true,
        saveSettingsFestivitiesSuccess: false,
      };
    case SAVE_VIRTUAL_OPERATOR_SETTINGS_CLOSING_REQUEST:
      return {
        ...state,
        saveSettingsClosingLoaded: false,
        saveSettingsClosingError: false,
        saveSettingsClosingSuccess: false,
      };
    case SAVE_VIRTUAL_OPERATOR_SETTINGS_CLOSING_SUCCESS:
      return {
        ...state,
        saveSettingsClosingLoaded: true,
        saveSettingsClosingError: false,
        saveSettingsClosingSuccess: true,
      };
    case SAVE_VIRTUAL_OPERATOR_SETTINGS_CLOSING_FAILURE:
      return {
        ...state,
        saveSettingsClosingLoaded: true,
        saveSettingsClosingError: true,
        saveSettingsClosingSuccess: false,
      };
    case FETCH_VIRTUAL_OPERATOR_STATISTICS_REQUEST:
      return {
        ...state,
        fetchStatisticsLoaded: false,
        fetchStatisticsError: false,
      };
    case FETCH_VIRTUAL_OPERATOR_STATISTICS_SUCCESS:
      return {
        ...state,
        statistics: action.data.statistics,
        totalStatistics: action.data.total,
        fetchStatisticsLoaded: true,
        fetchStatisticsError: false,
      };
    case FETCH_VIRTUAL_OPERATOR_STATISTICS_FAILURE:
      return {
        ...state,
        fetchStatisticsLoaded: true,
        fetchStatisticsError: true,
      };
    case FETCH_VIRTUAL_OPERATOR_CHAT_DETAILS_REQUEST:
      return {
        ...state,
        fetchChatDetailsLoaded: false,
        fetchChatDetailsError: false,
      };
    case FETCH_VIRTUAL_OPERATOR_CHAT_DETAILS_SUCCESS:
      return {
        ...state,
        details: action.data,
        fetchChatDetailsLoaded: true,
        fetchChatDetailsError: false,
      };
    case FETCH_VIRTUAL_OPERATOR_CHAT_DETAILS_FAILURE:
      return {
        ...state,
        fetchChatDetailsLoaded: true,
        fetchChatDetailsError: true,
      };
    case SET_VIRTUAL_OPERATOR_STATISTICS_FILTER:
      return {
        ...state,
        statisticsFilter: {
          ...state.statisticsFilter,
          ...action.filter,
        },
      };
    case FETCH_VIRTUAL_OPERATOR_MONITORING_REQUEST:
      return {
        ...state,
        fetchMonitoringLoaded: false,
        fetchMonitoringError: false,
      };
    case FETCH_VIRTUAL_OPERATOR_MONITORING_SUCCESS:
      return {
        ...state,
        monitoring: action.data,
        fetchMonitoringLoaded: true,
        fetchMonitoringError: false,
      };
    case FETCH_VIRTUAL_OPERATOR_MONITORING_FAILURE:
      return {
        ...state,
        fetchMonitoringLoaded: true,
        fetchMonitoringError: true,
      };
    case FETCH_VIRTUAL_OPERATOR_COSTS_REQUEST:
      return {
        ...state,
        fetchCostsLoaded: false,
        fetchCostsError: false,
      };
    case FETCH_VIRTUAL_OPERATOR_COSTS_SUCCESS:
      return {
        ...state,
        costs: action.data,
        fetchCostsLoaded: true,
        fetchCostsError: false,
      };
    case FETCH_VIRTUAL_OPERATOR_COSTS_FAILURE:
      return {
        ...state,
        fetchCostsLoaded: true,
        fetchCostsError: true,
      };
    case FETCH_VIRTUAL_OPERATOR_AMBROGIO_COSTS_REQUEST:
      return {
        ...state,
        fetchAmbrogioCostsLoaded: false,
        fetchAmbrogioCostsError: false,
      };
    case FETCH_VIRTUAL_OPERATOR_AMBROGIO_COSTS_SUCCESS:
      return {
        ...state,
        ambrogioCosts: action.data.data,
        totalAmbrogioCosts: action.data.total,
        totalAmbrogioExtraCosts: action.data.totalExtra,
        fetchAmbrogioCostsLoaded: true,
        fetchAmbrogioCostsError: false,
      };
    case FETCH_VIRTUAL_OPERATOR_AMBROGIO_COSTS_FAILURE:
      return {
        ...state,
        fetchAmbrogioCostsLoaded: true,
        fetchAmbrogioCostsError: true,
      };
    case FETCH_VIRTUAL_OPERATOR_AMBROGIO_PBXS_REQUEST:
      return {
        ...state,
        fetchAmbrogioPbxsLoaded: false,
        fetchAmbrogioPbxsError: false,
      };
    case FETCH_VIRTUAL_OPERATOR_AMBROGIO_PBXS_SUCCESS:
      return {
        ...state,
        ambrogioPbxs: action.data,
        fetchAmbrogioPbxsLoaded: true,
        fetchAmbrogioPbxsError: false,
      };
    case FETCH_VIRTUAL_OPERATOR_AMBROGIO_PBXS_FAILURE:
      return {
        ...state,
        fetchAmbrogioPbxsLoaded: true,
        fetchAmbrogioPbxsError: true,
      };
    case SAVE_VIRTUAL_OPERATOR_NO_CREDIT_RULE_REQUEST:
      return {
        ...state,
        saveNoCreditRuleLoaded: false,
        saveNoCreditRuleError: false,
      };
    case SAVE_VIRTUAL_OPERATOR_NO_CREDIT_RULE_SUCCESS:
      return {
        ...state,
        saveNoCreditRuleLoaded: true,
        saveNoCreditRuleError: false,
        saveNoCreditRuleSuccess: true,
      };
    case SAVE_VIRTUAL_OPERATOR_NO_CREDIT_RULE_FAILURE:
      return {
        ...state,
        saveNoCreditRuleLoaded: true,
        saveNoCreditRuleError: true,
        saveNoCreditRuleSuccess: false,
      };
    case SAVE_VIRTUAL_OPERATOR_TICKET_SETTINGS_REQUEST:
      return {
        ...state,
        saveTicketSettingsLoaded: false,
        saveTicketSettingsError: false,
      };
    case SAVE_VIRTUAL_OPERATOR_TICKET_SETTINGS_SUCCESS:
      return {
        ...state,
        saveTicketSettingsLoaded: true,
        saveTicketSettingsError: false,
        saveTicketSettingsSuccess: true,
      };
    case SAVE_VIRTUAL_OPERATOR_TICKET_SETTINGS_FAILURE:
      return {
        ...state,
        saveTicketSettingsLoaded: true,
        saveTicketSettingsError: true,
        saveTicketSettingsSuccess: false,
      };

    default:
      return state;
  }
}
